import axios from "axios";
import { store } from "../../../state-management/state-mgmt";
import Utility from "../../../shared/utility";
export default {
  getDocumentAccount(call, obj, showMessage) {
    return this.getData("/du/get_document_account", call, obj, showMessage);
  },
  getDocumentList(call, obj, showMessage) {
    return this.getData("/du/get_document_list", call, obj, showMessage);
  },
  getDocumentOrigin(call, obj, showMessage) {
    return this.getData("/du/get_document_origin", call, obj, showMessage);
  },
  getDocumentType(call, obj, showMessage) {
    return this.getData("/du/get_document_type", call, obj, showMessage);
  },
  getDocumentDifficulty(call, obj, showMessage) {
    return this.getData("/du/get_document_difficulty", call, obj, showMessage);
  },
  getDocumentStatus(call, obj, showMessage) {
    return this.getData("/du/get_document_status", call, obj, showMessage);
  },
  documentInsert(call, obj, showMessage) {
    return this.getData("/du/document_insert", call, obj, showMessage);
  },
  documentListView(call, obj, showMessage) {
    return this.getData("/du/document_account_list_view", call, obj, showMessage);
  },
  documentUpdate(call, obj, showMessage) {
    return this.getData("/du/document_update", call, obj, showMessage);
  },
  documentLoadMasters(call, obj, showMessage) {
    return this.getData("/du/document_load_masters", call, obj, showMessage);
  },
  documentGetByID(call, obj, showMessage) {
    return this.getData("/du/document_get_by_id", call, obj, showMessage);
  },
  documentEndUserGetByID(call, obj, showMessage) {
    return this.getData("/du/document_enduser_get_by_id", call, obj, showMessage);
  },
  documentApprovedList(call, obj, showMessage) {
    return this.getData("/du/document_approved_list", call, obj, showMessage);
  },
  documentEndUserList(call, obj, showMessage) {
    return this.getData("/du/document_end_user_list", call, obj, showMessage);
  },
  documentHistory(call, obj, showMessage) {
    return this.getData("/du/document_history", call, obj, showMessage);
  },
  documentTrainingReport(call, obj, showMessage) {
    return this.getData("/du/document_training_report", call, obj, showMessage);
  },
  documentApprovalGetByID(call, obj, showMessage) {
    return this.getData("/du/document_approval_get_by_id", call, obj, showMessage);
  },
  documentApproval(call, obj, showMessage) {
    return this.getData("/du/document_approval", call, obj, showMessage);
  },
  documentActionLogs(call, obj, showMessage) {
    return this.getData("/du/document_action_logs", call, obj, showMessage);
  },
  documentEndUserTraining(call, obj, showMessage) {
    return this.getData("/du/document_enduser_training", call, obj, showMessage);
  },
  getDocumentSasFileUrl(call, system_file) {
    return this.getData(`/du/document_get_sasfileurl?system_file=${system_file}`, call);
  },

  async getData(url, call, obj, showMessage) {
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    let res = {};
    if (call == "get") {
      res = await axios.get(url).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    } else {
      res = await axios.post(url, obj).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    }
    if (res !== undefined) {
      if (res.data.body.message != undefined || res.data.body.message != null) {
        if (!res?.data?.body?.message) {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(res.data.body.message),
          };
          store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = res.data.body.message;
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return {};
        }
        try {
          if (showMessage) {
            let Alert = {
              type: "success",
              isShow: true,
              message: res.data.message,
            };
            store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;

          if (this.isJson(res?.data?.body?.message)) return JSON.parse(res?.data?.body?.message);
          else return res?.data?.body?.message;
        } catch (err) {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(err),
          };
          store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = err.message;
          return {};
        }
      } else if (res.data.body.message == null) {
        if (res.data.body !== null) {
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return res?.data?.body;
        } else {
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return JSON.parse('{"message":"NA"}');
        }
      } else {
        if (!res?.data?.message) {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(res.data.message),
          };
          store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = res.data.message;
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return {};
        }
        try {
          if (showMessage) {
            let Alert = {
              type: "success",
              isShow: true,
              message: res.data.message,
            };
            store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          return JSON.parse(res?.data?.message);
        } catch (err) {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(err),
          };
          store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = err.message;
          return {};
        }
      }
    } else {
      LoaderDialog.visible = false;
      store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      return JSON.parse('{"message":"NA"}');
    }
  },
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },
};
